import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { SignwithDigitalDeviceClientResponse } from '../../@types/digitalSignature/signWithDigitalDevice'

type Store = {
  signWithDigitalDevice: SignwithDigitalDeviceClientResponse | null
  setSignWithDigitalDevice: (
    signWithDigitalDevice: SignwithDigitalDeviceClientResponse,
  ) => void
}

export const useSignWithDigitalDeviceStore = create<Store>()(
  devtools(
    (set) => ({
      signWithDigitalDevice: null,
      setSignWithDigitalDevice: (signWithDigitalDevice) =>
        set({ signWithDigitalDevice }),
    }),
    { name: 'SignWithDigitalDeviceStore ' },
  ),
)
